import alumunium1 from "../assests/Aluminium & Zinc die casting parts/Aluminium & Zinc die casting parts2.webp";
import alumunium2 from "../assests/Aluminium & Zinc die casting parts/aluminium-components-500x500.webp";
import alumunium3 from "../assests/Aluminium & Zinc die casting parts/aluminium-die-casting-parts-500x500 (1).webp";
import alumunium4 from "../assests/Aluminium & Zinc die casting parts/aluminium-die-casting-parts-500x500 (2).webp";
import alumunium5 from "../assests/Aluminium & Zinc die casting parts/aluminium-die-casting-parts-500x500.webp";
import alumunium6 from "../assests/Aluminium & Zinc die casting parts/aluminum-castings-500x500.webp";
import alumunium7 from "../assests/Aluminium & Zinc die casting parts/aluminum-die-castings-500x500.webp";
import alumunium8 from "../assests/Aluminium & Zinc die casting parts/aluminum-metal-castings-500x500.webp";
import alumunium9 from "../assests/Aluminium & Zinc die casting parts/automobile-die-casting-components-500x500.webp";
import alumunium10 from "../assests/Aluminium & Zinc die casting parts/casting-and-forging-parts-500x500.webp";
import brass1 from "./../assests/Brass components/aluminium-cylindrical-sleeve-2-500x500.webp";
import brass2 from "./../assests/Brass components/brass-cnc-turned-component-1000x1000.webp";
import brass3 from "./../assests/Brass components/brass-contact-500x500.webp";
import brass4 from "./../assests/Brass components/brass-precision-parts-500x500.webp";
import brass5 from "./../assests/Brass components/brass-precision-turned-components-500x500.webp";
import brass6 from "./../assests/Brass components/brass-surgical-components-500x500.webp";
import brass7 from "./../assests/Brass components/brass-turned-component-500x500.webp";
import brass8 from "./../assests/Brass components/photoroom-20220227-130105-01-jpeg-500x500.webp";
import brass9 from "./../assests/Brass components/precision-brass-components-500x500.webp";
import brass10 from "./../assests/Brass components/spe-parts-jcbi-india-3--500x500.webp";
import brass11 from "./../assests/Brass components/special-brass-turned-parts-250x250.webp";
import brass12 from "./../assests/Brass components/stainless-steel-automotive-turned-components-500x500.webp";
import forging1 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners 2.webp";
import forging2 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners 6.webp";
import forging3 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners 7.webp";
import forging4 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners.webp";
import forging5 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners1.webp";
import forging6 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners3.webp";
import forging7 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners5.webp";
import forging8 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners8.webp";
import forging9 from "./../assests/Hot forging & Cold forging of Fasteners/Hot forging & Cold forging of Fasteners4.webp";
import plastics1 from "./../assests/Plastic injection parts/ketron-peek-1000-500x500.webp";
import plastics2 from "./../assests/Plastic injection parts/plastic-injection-molded-parts-500x500.webp";
import plastics3 from "./../assests/Plastic injection parts/plastic-injection-molding-parts-500x500 (1).webp";
import plastics4 from "./../assests/Plastic injection parts/plastic-injection-molding-parts-500x500.webp";
import plastics5 from "./../assests/Plastic injection parts/plastic-injection-molding-parts-scaled-500x500.webp";
import plastics6 from "./../assests/Plastic injection parts/plastic-molded-parts-500x500.webp";
import plastics7 from "./../assests/Plastic injection parts/plastic-mould-components-500x500 (1).webp";
import plastics8 from "./../assests/Plastic injection parts/plastic-mould-components-500x500.webp";
import plastics9 from "./../assests/Plastic injection parts/plastic-mould-components-500x500.webp";
import plastics10 from "./../assests/Plastic injection parts/product-250x250.webp";
import powder1 from "./../assests/Powder metallurgy Parts/0-500x500.webp";
import powder2 from "./../assests/Powder metallurgy Parts/concave-mantle-500x500.webp";
import powder3 from "./../assests/Powder metallurgy Parts/cone-crusher-parts-500x500.webp";
import powder4 from "./../assests/Powder metallurgy Parts/powder-metallurgy-furnace-500x500.webp";
import powder5 from "./../assests/Powder metallurgy Parts/powdered-metal-components-500x500.webp";
import powder6 from "./../assests/Powder metallurgy Parts/stone-crusher-parts-500x500.webp";
import powder7 from "./../assests/Powder metallurgy Parts/tsp-4-tsp-23-powder-metallurgy-hss-500x500.webp";
import precision1 from './../assests/Precision Machining parts/2-500x500.webp';
import precision2 from './../assests/Precision Machining parts/high-precision-machined-parts-500x500.webp';
import precision3 from './../assests/Precision Machining parts/img_0193-copy-500x500.webp';
import precision4 from './../assests/Precision Machining parts/precision-automotive-parts-500x500.webp';
import precision5 from './../assests/Precision Machining parts/precision-machined-components-500x500 (1).webp';
import precision6 from './../assests/Precision Machining parts/precision-machined-components-500x500 (2).webp';
import precision7 from './../assests/Precision Machining parts/precision-machined-components-500x500 (3).webp';
import precision8 from './../assests/Precision Machining parts/precision-machined-components-500x500.webp';
import precision9 from './../assests/Precision Machining parts/turning-operations-precision-machined-components-500x500.webp';
import precision10 from './../assests/Precision Machining parts/vmc-coponet-500x500.webp';
import sheet1 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping par 2.webp';
import sheet2 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 1.webp';
import sheet3 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 3.webp';
import sheet4 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 4.webp';
import sheet5 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 5.webp';
import sheet6 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 6.webp';
import sheet7 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts 7.webp';
import sheet8 from './../assests/Sheet metal & Stamping parts/Sheet metal & Stamping parts.webp';
import tool1 from './../assests/WhatsApp_Image_2025-01-15_at_2.50.39_PM-removebg-preview.png';
import tool2 from './../assests/WhatsApp_Image_2025-01-15_at_2.51.10_PM-removebg-preview.png';
import tool3 from './../assests/WhatsApp_Image_2025-01-15_at_2.53.33_PM-removebg-preview.png';
import tool4 from './../assests/WhatsApp_Image_2025-01-15_at_2.54.12_PM-removebg-preview.png';
import tool5 from './../assests/WhatsApp_Image_2025-01-15_at_3.00.02_PM-removebg-preview.png';
import tool6 from './../assests/WhatsApp_Image_2025-01-15_at_3.03.23_PM-removebg-preview.png';


const GalleryData = [
  {
    title: "Customized Cutting Tools & Machinery Consumables ",
    images: [
       tool1,
       tool4,
       tool3, 
       tool2,
       tool5,
      //  tool6
    ],
  },
  {
    title: "Aluminium & Zinc die casting parts",
    images: [
      alumunium1,
      alumunium2,
      alumunium3,
      alumunium4,
      alumunium5,
      alumunium6,
      alumunium7,
      alumunium9,
      alumunium10,
    ],
  },
  {
    title: "Brass components",
    images: [
      brass1,
      brass2,
      brass3,
      brass4,
      brass5,
      brass6,
      brass7,
      brass8,
      brass9,
      brass10,
      brass11,
      brass12,
    ],
  },
  {
    title: "Hot forging & Cold forging of Fasteners",
    images: [
      forging1,
      forging2,
      forging3,
      forging4,
      forging5,
      forging6,
      forging7,
      forging8,
      forging9,
    ],
  },
  {
    title: "Plastic injection parts",
    images: [
      plastics1,
      plastics2,
      plastics3,
      plastics4,
     
    ],
  },
 
  {
    title: "Precision Machining parts",
    images: [
      precision1,
      precision2,
      precision3,
      precision4,
      precision5,
      alumunium8,

      precision6,
      precision7,
      precision8,
      precision9,
      precision10,
    ],
  },
  {
    title: "Sheet metal & Stamping parts",
    images: [
      sheet1,
      sheet2,
      sheet3,
      sheet4,
      sheet5,
      sheet6,
      sheet7,
      sheet8,
    ],
  },
];
export default GalleryData;
